
<template>
  <article id="exhibit-page" class="column content page">
    <h1>70 <sup>&times;</sup> 40 <sup>&times;</sup> 50</h1>
    <p>We invited eight recent graduates from London-based craft or industrial design courses to present a sample of their work in these diminutive display boxes; just 70 <sup>&times;</sup> 40 <sup>&times;</sup> 50 cm. Although small, the spaces provide a genuine platform for these, some of the city’s freshest new talents, to communicate a ‘taste’ of their ideas, solutions, motivations and preoccupations during London Design Festival.</p>
    <p>We purposefully selected graduates from a diverse range of design-related courses and institutions in the capital, hoping to demonstrate the breadth of design work currently being nurtured in London. We encourage you to further explore their work.</p>

    <div id="artists">
      <exhibit-item
        v-for="artist in exhibit"
        :key="artist.index"
        v-bind:artist="artist">
      </exhibit-item>
    </div>
  </article>
</template>

<script>
import ExhibitItem from '@/components/ExhibitPage/ExhibitItem'

export default {
  name: 'exhibit-page',
  props: ['exhibit'],
  components: { ExhibitItem },
  beforeCreate: function () {
    document.body.className = 'exhibit-page'
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ExhibitPage/ExhibitPage.vue?039192c6